import React from 'react';

interface INicheCarwashSvgProps {
  width?: number;
  height?: number;
}

export const NicheCarwashSvg: React.FC<INicheCarwashSvgProps> = ({
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 27V20.5C11 18 13 16 15.5 16H24.5C27 16 29 18 29 20.5V27"
        stroke="#4CAF50"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="15" cy="28" r="2.5" fill="#4CAF50" />
      <circle cx="25" cy="28" r="2.5" fill="#4CAF50" />
    </svg>
  );
};
